import { useGLTF } from '@react-three/drei';
import { observer } from 'mobx-react';
import { ReactNode } from 'react';
import * as THREE from 'three';

import { LoadableMeshState } from '../core/LoadableMeshState';

interface MeshProps {
  state: LoadableMeshState;
  children?: ReactNode;
}

function Mesh({ children, state }: MeshProps) {
  const { nodes } = useGLTF(state.url);
  const { materials } = useGLTF(state.materialUrl);

  const mesh = nodes[state.name] || nodes[state.name.toLowerCase()];
  const material = materials[state.materialName] || materials[state.materialName.toLowerCase()];

  if (mesh instanceof THREE.Mesh) {
    return (
      <mesh
        geometry={mesh.geometry}
        position={new THREE.Vector3(state.position.x, state.position.y, state.position.z)}
        material={material}
        castShadow
        receiveShadow
      >
        {children}
      </mesh>
    );
  }

  return null;
}

export default observer(Mesh);
